import { InputAdornment, TextField } from '@mui/material';

const TypeBic = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
}) => {
  const value = dataCollection[field.key] || '';
  const showError = Boolean(value && errors[field.key]);

  function handleTextChange(event) {
    updateValidationOnChange(
      [field.key],
      event.target.value.toUpperCase().replace(/\s/g, '')
    );
  }

  return (
    <TextField
      sx={{
        gridColumn: field.colspan
          ? `span ${field.colspan} / span ${field.colspan}`
          : 'auto',
      }}
      size={size}
      label={field.label}
      value={value}
      onChange={handleTextChange}
      error={showError}
      helperText={showError ? errors[field.key] : undefined}
      inputProps={{ maxLength: 11, autoCapitalize: 'characters' }}
      InputProps={{
        endAdornment: field.unit ? (
          <InputAdornment position="end">{field.unit}</InputAdornment>
        ) : null,
      }}
    />
  );
};

export default TypeBic;
